import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { StyledActionButton } from '@/components/Buttons.tsx'
import { FormStyled, FormSubmit } from '@/components/templates/Form.tsx'
import { ScrollableContent } from '@/components/templates/ScreenLayout.tsx'
import { ScreenWrapper } from '@/components/templates/ScreenWrapper.tsx'
import { TimeSlots } from '@/components/templates/TimeSlots.tsx'
import { Description, Header1 } from '@/components/Text.tsx'
import { useTrackFormProgress } from '@/hooks/useTrackFormProgress.ts'
import { useAppointmentStore } from '@/store.ts'

import { XpertFormStep } from '../../utils/XpertFormSteps.ts'

const AutomaticBooking = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'automaticBooking',
  })
  const navigate = useNavigate()
  const slots = useAppointmentStore.getState().getSortedSlots()
  const { trackFormInteraction } = useTrackFormProgress(
    XpertFormStep.DifferentTimeSlot,
  )

  return (
    <ScreenWrapper>
      <FormStyled method="post">
        <ScrollableContent>
          <Header1>{t('header')}</Header1>
          <Description>{t('description')}</Description>

          <TimeSlots
            slots={slots}
            onSlotClick={() => {
              trackFormInteraction({
                action: 'click',
                formFieldName: 'timeSlot',
              })
            }}
          />
        </ScrollableContent>

        <FormSubmit>
          <StyledActionButton
            variant="Primary"
            type="submit"
            onClick={() => {
              trackFormInteraction({
                action: 'next',
                formFieldName: 'submit',
              })
            }}
          >
            {t('actions.confirmAppointment')}
          </StyledActionButton>

          <StyledActionButton
            variant="Secondary"
            id="createManualBooking"
            onClick={(e) => {
              e.preventDefault()
              navigate('/referral/manual-booking/select-clinic')
              trackFormInteraction({
                action: 'next',
                formFieldName: 'createManualBooking',
              })
            }}
          >
            {t('actions.createManualBooking')}
          </StyledActionButton>
        </FormSubmit>
      </FormStyled>
    </ScreenWrapper>
  )
}

export { AutomaticBooking }
